export const postGenericDocuments = {
    source: 'data',
    route: '/document/generic/documents',
    method: 'POST',
    contentType: 'multipart/form-data',
};
